import { render, staticRenderFns } from "./AspekJasmaniCard.vue?vue&type=template&id=45d682dc&scoped=true"
import script from "./AspekJasmaniCard.vue?vue&type=script&lang=js"
export * from "./AspekJasmaniCard.vue?vue&type=script&lang=js"
import style0 from "./AspekJasmaniCard.vue?vue&type=style&index=0&id=45d682dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d682dc",
  null
  
)

export default component.exports